import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { renderAutoCompleteSingleSelect,renderTextField } from '../../../../components/reduxFields';
import { getMasterData, getPayerByPatientId, ReSubmitClaim, SubmitEDIClaim, SubmitClaim_Secondary } from './actions/ManageClaimActions';
import { extractDataFromArray } from '../../../../actions/utilAction';

import FlatButton from 'material-ui/FlatButton';
import validate from './ValidateSubmitClaim';

class ResubmitClaimModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      insuranceCompaniesList: props.insuranceCompaniesList ? props.insuranceCompaniesList : [],
      ClaimId: props.ClaimId,
      PayerClaimControlNumber: props.PayerClaimControlNumber,
      SubmissionType: props.SubmissionType,
      PatientId: props.PatientId,
      OrganizationId: props.OrganizationId,
      ClaimForm: [{ id: 1, value: 'Form 1500' }, { id: 2, value: 'EDI 837' }],
      // ClaimForm: [{ id: 1, value: 'Form 1500' }],
      ClaimFormPrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
      // ClaimFormPrintFormat: [{ id: 1, value: 'Printed' }],
      IsNonEDIPayer: false,
      IsClaimForm1500: false,
      IsEDISubmission: this.props.SubmissionType === 1 ? false : true,
      IsVoidOrCorrectedClaim: false,
    };
  }

  componentWillMount() {
   // console.log('this.props.SubmissionType.......', this.props.SubmissionType)
    let masterData = { 'masterdata': 'CLAIMRESUBMISSIONREASON' };
    this.props.getMasterData(masterData);
    this.props.getPayerByPatientId(this.state.PatientId, 'BOTH');
    if (this.props.SubmissionType === 1) {
      this.setState({ ClaimForm: [{ id: 1, value: 'Form 1500' }] });
    } else {
      this.setState({ ClaimForm: [{ id: 1, value: 'Form 1500' }, { id: 2, value: 'EDI 837' }] });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.downloadStatus && this.props.downloadStatus !== nextProps.downloadStatus) {
      // this.setState({ open: false });
      // this.props.closeDialog();
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      let masterData = nextProps.master_data;
      this.setState({
        masterPractitionerList: masterData.allStaffs,
      });
    }

    if (nextProps.insuranceCompaniesList && this.props.insuranceCompaniesList !== nextProps.insuranceCompaniesList) {
      this.setState({
        insuranceCompaniesList: nextProps.insuranceCompaniesList,
      });
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    // console.log('insuranceCompanyId............', input, selectedRecord)
    if (input.name === 'insuranceCompanyId') {
      if (selectedRecord.value !== '') {
        let objInsuranceCompanies = extractDataFromArray(this.state.insuranceCompaniesList, selectedRecord.value);
        if (objInsuranceCompanies.payerPreference !== 'Primary') {

        } else {
          if (objInsuranceCompanies.isEDIPayer) {
            this.setState({ IsNonEDIPayer: false, IsClaimForm1500: false, ClaimForm: [{ id: 1, value: 'Form 1500' }, { id: 2, value: 'EDI 837' }] });
          } else {
            this.setState({ IsNonEDIPayer: true, IsClaimForm1500: true, ClaimForm: [{ id: 1, value: 'Form 1500' }] });
          }
        }
      } else {
        this.setState({
          ClaimForm: [{ id: 1, value: 'Form 1500' }, { id: 2, value: 'EDI 837' }],
          ClaimFormPrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
          // ClaimFormPrintFormat: [{ id: 1, value: 'Printed' }],
          IsNonEDIPayer: false,
          IsClaimForm1500: false,
          IsEDISubmission: false,
          IsVoidOrCorrectedClaim: false,
        });
      }
    } else if (input.name === 'claimForm') {
      if (selectedRecord.value !== '') {
        if (selectedRecord.value === 1) {
          this.setState({ IsClaimForm1500: true, IsEDISubmission: false, IsVoidOrCorrectedClaim: false });
        } else if (selectedRecord.value === 2) {
          this.setState({ IsClaimForm1500: false, IsEDISubmission: true, IsVoidOrCorrectedClaim: false });
        }
      } else {
        this.setState({ IsClaimForm1500: false, IsEDISubmission: false, IsVoidOrCorrectedClaim: false });
      }
    } else if (input.name === 'ResubmissionReason') {
      if (selectedRecord.value !== '') {
        // if (selectedRecord.value === 2 || selectedRecord.value === 3 || selectedRecord.value === 4) {
        //   this.setState({ IsVoidOrCorrectedClaim: true });
        // } else {
        //   this.setState({ IsVoidOrCorrectedClaim: false });
        // }
        if (selectedRecord.value === 2 || selectedRecord.value === 3 || selectedRecord.value === 4) {          
          this.setState({ IsVoidOrCorrectedClaim: true },()=>{
            this.props.dispatch(change('ResubmitClaimModal', 'PayerControlReferenceNumber', this.state.PayerClaimControlNumber));          
          });
        } else {
          this.setState({ IsVoidOrCorrectedClaim: false },()=>{
            this.props.dispatch(change('ResubmitClaimModal', 'PayerControlReferenceNumber', null));          
          });
        }
      } 
    }    
    input.onChange(selectedRecord.value);
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  onSubmitHandler(formData) {
    let claimFormPrintFormat = formData.claimFormPrintFormat;
    // console.log('formData.claimForm.................', formData.claimForm);
    let resubmissionClaimReason = this.props.masterResubmissionReason.find(((obj) => obj.id === formData.ResubmissionReason));
    if (formData.claimForm === 1) {
      this.props.SubmitClaim_Secondary(this.state.ClaimId, formData.insuranceCompanyId, claimFormPrintFormat);
    } else {
      formData.resubmissionReason = resubmissionClaimReason.resubmissionReason;      
      formData.PayerControlReferenceNumber = formData.PayerControlReferenceNumber ? formData.PayerControlReferenceNumber : '';
      this.props.ReSubmitClaim(this.state.ClaimId, formData.insuranceCompanyId, formData.resubmissionReason, formData.PayerControlReferenceNumber);
    }
    this.handleClose();
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Dialog className="custom_modal"
        title={'Generate Claim CL' + this.props.ClaimId}
        modal={false}
        open={this.state.open}
        autoScrollBodyContent={true}>
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="insuranceCompanyId"
                    label="Payer Name"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.insuranceCompaniesList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className='col-sm-6 require mt-35' >
                  <Field
                    name="claimForm"
                    label="Claim Form"
                    options={this.state.ClaimForm}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              <div className="row">
                {this.state.IsClaimForm1500 ?
                  <div className='col-sm-6 require  mt-35' >
                    <Field
                      name="claimFormPrintFormat"
                      label="Print Formats"
                      options={this.state.ClaimFormPrintFormat}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect} />
                  </div>
                  : null}
                {this.state.IsEDISubmission ?
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="ResubmissionReason"
                      label='Resubmission Reason'
                      options={this.props.resubmissionReason}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                  : null}

                  {this.state.IsVoidOrCorrectedClaim ?
                  <div className="col-sm-6 require">
                     <Field name="PayerControlReferenceNumber"
                      label="Control Reference Number"
                      maxLength="20"
                      component={renderTextField} />
                  </div>
                  : null}                  
              </div>
              <div className="row">
                <div className="col-sm-6 require mt-40">
                </div>
                <div className="col-sm-6 pt20 btn_rt">
                  <FlatButton className="grey_btn"
                    label="Cancel" onTouchTap={this.handleClose} />
                  <FlatButton className="blue_btn"
                    label="Generate Claim" primary={true} type='submit' />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

ResubmitClaimModal = reduxForm({
  form: 'ResubmitClaimModal',
  validate,
  enableReinitialize: true,
})(ResubmitClaimModal);

function mapStateToProps(state, ownProps) {
  // console.log('state.billing.master_data.claimResubmissionReason............', state.billing.master_data.claimResubmissionReason);
  // console.log('state.billing.insuranceCompaniesList.data............',state.billing.insuranceCompaniesList)
  let resubmissionReason = [];
  if (state.billing.master_data && state.billing.master_data.claimResubmissionReason) {
    resubmissionReason = state.billing.master_data.claimResubmissionReason.map((obj) => {
      return {
        id: obj.id,
        value: obj.resubmissionCode + ' - ' + obj.description,
      };
    });
  }
  return {
    resubmissionReason: resubmissionReason,
    masterResubmissionReason: state.billing.master_data.claimResubmissionReason,
    ClaimId: ownProps.ClaimId,
    SubmissionType: ownProps.SubmissionType,
    PatientId: ownProps.PatientId,
    OrganizationId: ownProps.OrganizationId,
    insuranceCompaniesList: state.billing.insuranceCompaniesList.data,
    downloadStatus: state.billing.downloadStatus,
  };
}

export default connect(mapStateToProps, { getPayerByPatientId, ReSubmitClaim, SubmitEDIClaim, getMasterData, SubmitClaim_Secondary })(ResubmitClaimModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/ResubmitClaim_Modal.js